// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../endOfISOWeekYear/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var endOfISOWeekYear = convertToFP(fn, 1);
export default endOfISOWeekYear;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/endOfISOWeekYear/index.js
// module id = 862
// module chunks = 0